import React, { Component } from 'react'
import {Spin, Table, Layout, Icon } from 'antd'
import { topUpLog } from '_src/api/api'

class RechargeLog extends Component {
	state = {
		isLoading: false,
		createModelVisible: false,
		params: {
			pageNum: 0,
			pageSize: 10,
		},
		pageData: {
			total: 0,
			current: 1,
		},
		list: [],
		columns: [
			{
				title: '充值日期',
				key: 'id',
				render: item => item.updateAt || item.createAt
			},
			{
				title: '充值金额',
				dataIndex: 'money',
				render: item => (item / 100).toFixed(2)
			},
			{
				title: '流水单号',
				dataIndex: 'orderSn',
			},
			{
				title: '支付方式',
				align: 'center',
				render: item => item.payment && item.payment.type === 'native_ali' ? '支付宝' : '微信支付'
			},
			{
				title: '状态',
				align: 'center',
				render: item => item.payment && item.payment.status ? <span style={{color: '#1890ff'}} ><Icon type="check-circle" theme="twoTone" /> 已支付</span> : <span>未支付</span>
			},
		]
	}

	componentDidMount () {
		const { params } = this.state
		this.loadList(params)
	}

	loadList (params) {
		this.setState({ isLoading: true })
		topUpLog(params)
			.then(res => {
				this.setState({
					list: res.data.content,
					isLoading: false,
					pageData: {
						current: res.data.pageable.pageNumber + 1,
						total: res.data.totalElements,
						pageSize: res.data.pageable.pageSize,
					},
				})
			})
			.catch(err => {
				this.setState({
					list: [],
					isLoading: false,
					pageData: {
						current: 0,
						total: 0,
						pageSize: 0,
					},
				})
			})
	}

	// 分页
	onPageChange = (e) => {
		const { params } = this.state
		params.pageNum = e.current - 1
		this.loadList(params)
	}

	render () {
		const {
			isLoading,
			list,
			columns,
			pageData,
		} = this.state
		return (
			<Layout className="goodType-page" style={{ padding: 20, backgroundColor: 'white' }}>
				{this.state.isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
				{
					!isLoading && (
						<Table
							columns={columns}
							dataSource={list}
							bordered
							rowKey="id"
							pagination={{
								current: pageData.current,
								total: pageData.total,
								pageSize: pageData.pageSize,
							}}
							onChange={this.onPageChange}
						/>
					)
				}
			</Layout>
		)
	}
}

export default RechargeLog